import * as React from "react";
import { Grid, Stack } from "@mui/material";
import request from "src/utils/request";
import { useAuth } from "src/components/providers/auth-context";
import type { TemplateDetails } from "src/scenes/templates-details/types";
import Typography from "@mui/material/Typography";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PersonIcon from "@mui/icons-material/Person";
import SubtitlesIcon from "@mui/icons-material/Subtitles";
import ViewButton from "src/scenes/templates-details/view-button";
import { TeamsProvider } from "src/scenes/teams/teams-provider";

const TemplatesDetails = () => {
    const [allTemplates, setAllTemplates] = React.useState<TemplateDetails>();

    const { isDemo } = useAuth();
    const getTemplates = async () => {
        let response;
        if (isDemo) {
            // @ts-expect-error: Ignore TS1323 for dynamic import
            response = (await import("src/components/providers/mock-data/template-views")).default;
        } else {
            response = await request(`/api/template/views`, {
                method: "GET",
            });
        }
        setAllTemplates(response);
    };
    React.useEffect(() => {
        getTemplates();
    }, []);

    return (
        <TeamsProvider>
            <Stack mb={8} style={{ width: "100%" }}>
                <Typography style={{ marginBottom: "16px" }}>All available dashboards</Typography>
                <Stack direction="row" spacing={0.5} mt={2} mb={2}>
                    <PersonIcon />
                    <Typography>Personal Dashboards</Typography>
                </Stack>
                <Grid container md={12} spacing={2} alignItems="flex-start">
                    {allTemplates?.personalViews?.map((view, index) => (
                        <Grid item md={3} key={view.id || `personal-${index}`}>
                            <ViewButton
                                dashboards={view.dashboards}
                                name="Personal"
                                teamId={undefined}
                            />
                        </Grid>
                    ))}
                </Grid>
                <Stack direction="row" spacing={0.5} mt={2} mb={2}>
                    <SubtitlesIcon />
                    <Typography>Per Repo Dashboards</Typography>
                </Stack>
                <Grid container md={12} spacing={2} alignItems="flex-start">
                    {allTemplates?.repoViews?.map((view, index) => (
                        <Grid item md={3} key={view.id || `repo-${index}`}>
                            <ViewButton
                                dashboards={view.dashboards}
                                name="Per Repo"
                                teamId={undefined}
                            />
                        </Grid>
                    ))}
                </Grid>
                <Stack direction="row" spacing={0.5} mt={2} mb={2}>
                    <PeopleAltIcon />
                    <Typography>Teams Dashboards</Typography>
                </Stack>
                <Grid container md={12} spacing={2} alignItems="flex-start">
                    {allTemplates?.teamViews &&
                        allTemplates.teamViews.length > 0 &&
                        allTemplates.teamViews.map((team) =>
                            team.views?.map((view) => (
                                <Grid item md={3} key={view.id || `${team.teamId}-${view.id}`}>
                                    <ViewButton
                                        dashboards={view.dashboards}
                                        name={team.teamName}
                                        teamId={team.teamId}
                                    />
                                </Grid>
                            ))
                        )}
                </Grid>
            </Stack>
        </TeamsProvider>
    );
};

export default TemplatesDetails;
